import { render, staticRenderFns } from "./RelatedCategories.vue?vue&type=template&id=1e50afe2"
import script from "./RelatedCategories.vue?vue&type=script&lang=ts"
export * from "./RelatedCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports